import { LMPSessionStatus } from '@constants/index';

export const getIsCancelledSession = (status) => {
  if (
    [
      LMPSessionStatus.EDUCATOR_CANCELLED,
      LMPSessionStatus.MODERATOR_CANCELLED,
      LMPSessionStatus.CANCELLED
    ].includes(status)
  )
    return true;
  return false;
};

export const getIsEducatorAssigned = (status, educatorUID) => {
  if (status !== LMPSessionStatus.ASSIGNMENT_DUE && educatorUID) return true;
  return false;
};

export const STEP_INFO = {
  PREFERENCES_DRAWER: 1,
  SELECT_YOUR_SUBJECT_DRAWER: 2,
  BOOK_A_TIME_SLOT: 3,
  DESCRIBE_YOUR_SESSION: 4,
  SESSION_BOOKED: 5
};

export const REVERSE_STEP_INFO = {
  1: 'PREFERENCES_DRAWER',
  2: 'SELECT_YOUR_SUBJECT_DRAWER',
  3: 'BOOK_A_TIME_SLOT',
  4: 'DESCRIBE_YOUR_SESSION',
  5: 'SESSION_BOOKED'
};

export const GENDER_MAPPING = {
  2: 'Male',
  3: 'Female',
  4: 'Others'
};

export const LANGUAGE_MAPPING = {
  1: 'English',
  2: 'Hindi'
};

export const getValidImageName = (fileName, defaultName = 'default.jpg') =>
  fileName?.match(/.(jpg|jpeg|png)$/i) ? fileName : defaultName;

export const getVerticalDataFromLevel5UID = (verticals, level5UID) => {
  const level5Data = verticals?.find((data) => data.uid === level5UID);
  return level5Data;
};

export const getSlotDurationsFromLevel15UID = (
  verticals,
  level5UID,
  level10UID,
  level15UID
) => {
  const level5Data = verticals?.find((data) => data.uid === level5UID);
  const level10Data = level5Data?.children?.find(
    (level10data) => level10data.uid === level10UID
  );
  const level15Data = level10Data?.children?.find(
    (level15data) => level15data.uid === level15UID
  ).durations;
  return level15Data;
};
